import { render, staticRenderFns } from "./AppMembers.vue?vue&type=template&id=7ffce384&scoped=true&lang=pug&"
import script from "./AppMembers.vue?vue&type=script&lang=js&"
export * from "./AppMembers.vue?vue&type=script&lang=js&"
import style0 from "./AppMembers.vue?vue&type=style&index=0&id=7ffce384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffce384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
